import * as types from './actionTypes';

export const getList = () => {
    return{
      type: types.GET_CHEQUE_LIST_REQUEST
    }
};

export const getListSuccess = data => {
    return {
        type: types.GET_CHEQUE_LIST_SUCCESS,
        payLoad: data
    };
};
export const getListFailure = () => {
    return {
        type: types.GET_CHEQUE_LIST_FAILURE
    };
};

export const changeStatus = (chequeId, newStatus, source_type = null, source_id = null) =>{
  return{
    type: types.CHANGE_CHEQUE_STATUE_REQUEST,
    chequeId,
    newStatus,
    source_type,
    source_id,
  }
};
export const changeStatusSuccess = (cheque_data) =>{
  return{
    type: types.CHANGE_CHEQUE_STATUE_SUCCESS,
    payLoad:{cheque_data},
  }
};
export const changeStatusFailure = (chequeId) =>{
  return{
    type: types.CHANGE_CHEQUE_STATUE_FAILURE,
    chequeId
  }
};

export const changeSourceId = (sourceId) =>{
  return{
    type: types.CHANGE_CHEQUE_SOURCE_ID,
    payLoad: sourceId
  }
};

export const changeSourceType = (sourceType) =>{
  return{
    type: types.CHANGE_CHEQUE_SOURCE_TYPE,
    payLoad: sourceType
  }
};
export const changeSourceInfo = (source) => {
  return {
    type: types.CHANGE_CHEQUE_SOURCE_INFO,
    payLoad: {source}
  }
};